<div class="wrapper">
    <main class="middle-content">
        <div class="page_title_block">
            <h1 class="page_title">Journal Management / Edit</h1>
        </div>
        <div class="content-section">
            <div class="order-view max-WT setting-page">
                <div class="add-store-block input-style mb-3">
                    <form [formGroup]="form">
                        <div class="form-group row align-items-baseline">
                            <div class="col-md-12">
                                <label class="mt-3">Question : </label>
                                <input type="text" class="form-control" placeholder="Type your question"
                                    formControlName="question" maxlength="200"
                                    (keypress)="mainService.preventSpace($event)">
                                @if(form.get('question')?.hasError('required') && form.get('question')?.dirty){
                                <div class="text-danger">
                                    *Question is required.
                                </div>
                                }
                            </div>
                        </div>

                    </form>
                </div>
                <div class="text-center">
                    <button class="btn btn-large  max-WT-150 btn-theme" [disabled]="form.invalid"
                        (click)="updateJournalList()">Update</button>
                </div>
            </div>
        </div>
    </main>
</div>